import { Link } from "react-router-dom";
import useAppContext from "@/modules/app/useAppContext";
import { Button } from "@altimateai/lego";
import { IconArrowLeft } from "@tabler/icons-react";

interface Props {
  defaultUrl: string;
  className?: string;
  /** Always link to `defaultUrl` instead of the last visited path. Use for
   *  hierarchical back arrows where the last visited path may be a child of
   *  the current page — linking "back" to a child creates a navigation loop. */
  ignorePreviousPath?: boolean;
}
export const BackButton = ({ defaultUrl, className, ignorePreviousPath = false }: Props) => {
  const {
    state: { previousPath },
  } = useAppContext();

  return (
    <Button
      title="Click to go back"
      asChild
      aria-label="Back"
      variant="ghost"
      className={className}
      size={"icon"}
    >
      <Link to={ignorePreviousPath ? defaultUrl : previousPath || defaultUrl}>
        <IconArrowLeft title="Back Icon" />
      </Link>
    </Button>
  );
};
